/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';
import {Component} from 'preact';
import PropTypes from 'prop-types';
import {Store} from '../Store.js';
import {getSeashotWithId} from '../api.js';
/*:: import type {User} from '../api.js'; */
import {SeashotViewAsync as SeashotView} from './SeashotView.js';

/*:: type Props = {
  +className: string,
  +viewMode: 'large' | 'medium' | 'small',
  +store: Store,
  +onLikedChange?: (seashotId: string, liked: boolean) => void,
}; */

export class SeashotsList extends Component /*:: <Props> */ {
  static propTypes = {
    className    : PropTypes.string.isRequired,
    viewMode     : PropTypes.oneOf(['large', 'medium', 'small']).isRequired,
    store        : PropTypes.instanceOf(Store).isRequired,
    onLikedChange: PropTypes.func,
  };

  handleStoreChange /*: () => void */ = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    this.props.store.hub.on('change', this.handleStoreChange);
  }
  componentWillUnmount() {
    this.props.store.hub.off('change', this.handleStoreChange);
  }

  render() /*: React$Node */ {
    const {className, viewMode, store, onLikedChange} = this.props;
    const layout =
      viewMode === 'large'
        ? 'medium'
        : viewMode === 'medium'
        ? 'small'
        : 'tiny';

    return html`
      <ol className=${`${className} -${viewMode}`}>
        ${store.seashotsList.map(function(seashotId /*: string */) {
          const onSeashotRatingChange =
            onLikedChange && onLikedChange.bind(null, seashotId);
          return html`
            <${SeashotView}
              key=${seashotId}
              component="li"
              layout=${layout}
              seashot=${getSeashotWithId(seashotId)}
              onLikedChange=${onSeashotRatingChange}
            />
          `;
        })}
      </ol>
    `;
  }
}
